@for (timeSlot of timeSlots(); track timeSlot.date) {
  <sd-item-wrapper (click)="onSelectDate(timeSlot.date)" [isActive]="timeSlot.date === selectedDate()">
    <sd-time-slot-date-item [timeSlot]="timeSlot"></sd-time-slot-date-item>
  </sd-item-wrapper>
}

@if (!selectedTimeSlot() && selectedAnotherDate(); as selectedAnotherDate) {
  <sd-item-wrapper (click)="onSelectDate(selectedAnotherDate)" [isActive]="selectedAnotherDate === selectedDate()">
    {{ selectedAnotherDate | date: 'd MMMM' }}
  </sd-item-wrapper>
}

<sd-another-date-item
  [timeSlots]="timeSlots()"
  (anotherDateSelected)="onSelectAnotherDate($event)"
></sd-another-date-item>
